class i {
  isRequiredStringValid(t, n) {
    return !!t && !!t.length && (!n || t.length <= n);
  }
  isStringValid(t, n) {
    return !n || ((t == null ? void 0 : t.length) ?? 0) <= n;
  }
  isBlank(t) {
    return t == null || t.toString().trim() === "";
  }
}
const s = new i();
export {
  s as default
};
